import React from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/route.css';
import AppStoreLink from '../../../components/common/AppStoreLink';

const DRIVER_PARTNER_CONTACT_PATH = '/about#contact';

/**
 * The terminal conversion band. This is the second and last Signal Yellow
 * surface on the page — the hard ask, placed after trust has been earned.
 */
const HomeCtaSection: React.FC = () => {
  return (
    <>
      <hr className="sw-lane-rule" aria-hidden="true" />

      <section className="sw-final-band">
        <div className="container">
          <span className="sw-eyebrow">Get started</span>
          <h2>Ready to move something?</h2>
          <p>
            Get a route estimate before you book. Final fare is confirmed before dispatch,
            with card payment secured first.
          </p>

          <div className="sw-final-actions">
            <AppStoreLink placement="final_band" />
            <Link className="sw-link-action" to={DRIVER_PARTNER_CONTACT_PATH}>
              Drive with us &rarr;
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeCtaSection;
